import { ISO3166Alpha3 } from "@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3";
import { getFullLanguageName } from "../consts/THREE_TO_FULL_LANGUAGE_NAME";
import { getTwoLetterCountryCode } from "../consts/THREE_TO_TWO_LETTER_COUNTRY_ISO_CODE";
var getCountryLabel = function(country) {
    switch(country){
        case undefined:
            return "US";
        case ISO3166Alpha3.GBR:
            return "UK";
        default:
            return getTwoLetterCountryCode(country);
    }
};
export var localeKeyToFullLanguageName = function(localeKey) {
    var includeCountry = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (localeKey.language === undefined) {
        return "";
    }
    if (includeCountry) {
        var fullLanguageName = getFullLanguageName(localeKey.language);
        var countryLabel = getCountryLabel(localeKey.country);
        return "".concat(fullLanguageName, " (").concat(countryLabel, ")");
    }
    return getFullLanguageName(localeKey.language);
};
